import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Template from "../../templates";
import { update, list } from "../../actions";

export default () => {
  const moduleName = `businesses/user`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [pending, setPending] = useState(true)

  const [id, setId] = useState(``);
  const [name, setName] = useState(``);
  const [tell, setTell] = useState(``);
  const [website, setWebsite] = useState(``);
  const [sheba, setSheba] = useState(``);
  const [sheba_owner, setShebaOwner] = useState(``);
  const [logo, setLogo] = useState(``);
  const [address, setAddress] = useState(``);
  const [zipcode, setZipcode] = useState(``);

  const handleClick = () => {
    dispatch(update(id, `businesses`));
  };

  useEffect(() => {
    if (appReducer.businesses_user_list != undefined) {
      setPending(false)
      let row = appReducer.businesses_user_list.data;
      if (row) {
        setId(row.id);
        setName(row.name);
        setAddress(row.address);
        setZipcode(row.zipcode);
        setTell(row.tell);
        setWebsite(row.website);
        setSheba(row.sheba);
        setShebaOwner(row.sheba_owner);
        setLogo(row.logo_full);
      }
    }
  }, [appReducer.businesses_user_list]);

  useEffect(() => {
    dispatch(list(moduleName));
  }, []);

  
  if (pending) {
    return <div></div>
  }

  if (!name) {
    return <div className=" bg-red-100 py-3 p-2">اطلاعات فروشگاه‌ شما یافت نشد</div>
  }

  return (
    <Template.Form>
      <Template.Input required label="نام" value={name} name="name" type="text" />
      <Template.Input
        label="وب‌ سایت"
        required
        value={website}
        name="website"
        className="ltr"
        type="text"
      />
      <Template.Input required label="تلفن" className="ltr" value={tell} name="tell" type="text" />
      <Template.Input
        label="شماره حساب"
        value={sheba}
        name="sheba"
        className="ltr"
        type="text"
      />
      <Template.Input
        value={sheba_owner}
        label="صاحب - صاحبان حساب"
        name="sheba_owner"
        type="text"
      />
      <Template.Input value={address} label="آدرس" name="address" type="text" />
      <Template.Input
        value={zipcode}
        label="کدپستی"
        name="zipcode"
        className="ltr"
        type="text"
      />
      <Template.FileInput
        deleteUrl="businesses/destroy_image"
        name="logo"
        rowId={id}
        value={logo && [logo]}
        label="لوگو"
      />
      <Template.Button label="ذخیره" onClick={handleClick} />
    </Template.Form>
  );
};
